// InputField.jsx
import React from "react";
import TextField from "@mui/material/TextField";
import "./input.css";

const InputField = ({
  title,
  placeholder,
  isRequired,
  value,
  onChange,
  readOnly = false, // Default to false if not provided
}) => {
  return (
    <div>
      <label className="input-label">
        {title} {isRequired && <span className="required">*</span>}
      </label>
      <TextField
        fullWidth
        required={isRequired}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        variant="outlined" // You can change to "filled" or "standard" if needed
        sx={{ marginBottom: 4, width: 500 }}
        InputProps={{
          readOnly: readOnly, // Set readOnly based on prop
        }}
        // Optionally, style read-only fields differently
        className={readOnly ? "read-only" : ""}
      />
    </div>
  );
};

export default InputField;
